
import { TablePaginationActions } from 'examples/Tables/CustomPaginationTable';
import DataTable from 'examples/Tables/DataTable';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import crudsService from 'services/cruds-service';

function EventsTable(props) {

    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState([])
    const [loader, setLoader] = useState(false)
    const [selectedEvent, setSelectedEvent] = useState([])

    async function fetchEvents(page, size) {
        try {
            setLoader(true)
            let resp = await crudsService.getDeviceEvent(props.id, page, size)

            if (resp.success) {
                let params = props.getRows(resp.data)
                setData(params)
                const { count } = resp;
                setTotal(count)
            }

        } catch (error) {
            console.error('fetchMonitorLogs', error)
        } finally {
            setLoader(false)
        }
    }

    async function onPageChange(e, page) {
        e.stopPropagation();
        setPage(page)
    }

    async function onRowsPerPageChange(e, value) {
        e.stopPropagation();
        setPageSize(value)
    }

    const removeEvents = async (e) => {
        try {
            if (!confirm('Are you sure you want to delete this event?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                setLoader(true)
                await crudsService.removeDeviceMultipleEvent(selectedEvent);
                toast.success('The Events has been successfully deleted')
                setSelectedEvent([])
                await fetchEvents(page, pageSize)
            }
        } catch (err) {
            console.error(err)
            if (err.hasOwnProperty('error')) {
                toast.error(err.error)
            }
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (page > 0) {
            fetchEvents(page, pageSize)
        }
    }, [page, pageSize])

    return (
        <>
            <DataTable
                table={{
                    columns: props.columns,
                    rows: data
                }}
                loader={loader}
                entriesPerPage={{ defaultValue: pageSize }}
                canPagination={false}
                selectedRows={selectedEvent}
                setSelectedRows={setSelectedEvent}
                deleteFunc={(e) => removeEvents(e)}
                {...props}
            />
            {
                total > pageSize &&
                <TablePaginationActions count={total} page={page} rowsPerPage={pageSize} onPageChange={onPageChange} onRowsPerPageChange={onRowsPerPageChange} />
            }
        </>
    )
}

export default EventsTable